import { useQuery } from '@tanstack/react-query';
import { useAccount } from 'wagmi';

import { getUserPoints } from '@/api/loans';
import { GET_MY_POINTS } from '@/utils/queryKey';

export const useMyPoints = () => {
  const { address } = useAccount();

  return useQuery({
    queryKey: [GET_MY_POINTS, address],
    queryFn: () => getUserPoints({ walletAddress: address! }),
    enabled: !!address,
  });
};
